import React, { useMemo } from 'react';

import {
	DuplicateCourseItem,
} from 'Views/Pages/Frontend/StudyPlanWizard/RequirementFulfilmentCheck/DuplicateCourseSelection';

import { DataIndex } from 'Util/DataIndexUtils';
import {
	CourseEntity,
	PlanSelectionEntity,
	RequirementEntity,
} from 'Models/Entities';
import {
	getRequirementComponents,
} from 'Util/RequirementEntityUtils';

export const useCourseDuplicates = (
	planSelections: PlanSelectionEntity[],
	duplicateCourseIds: string[],
	requirementsById: DataIndex<RequirementEntity>,
	coursesById: DataIndex<CourseEntity>,
	skip: boolean = false,
) => {
	// get a list of all courses with selected offerings
	// include the data of the course and its selected
	// offerings
	const duplicateCourses = useMemo(
		() => {
			if (skip) {
				return [];
			}

			if (!requirementsById) {
				return [];
			}

			const duplicateList: DuplicateCourseItem[] = [];

			for (const courseId of duplicateCourseIds) {
				const course = coursesById[courseId];

				const coursePlanSelections = planSelections
					.filter(planSelection => planSelection.courseId === courseId);

				if (!course.id) {
					throw new Error('Duplicated course is missing ID');
				}

				const duplicateComponents = getRequirementComponents(
					coursePlanSelections.map(selection => selection.locationId),
					requirementsById,
				);

				const courseDuplicates: DuplicateCourseItem = {
					key: course.id,
						/**
						 * every item indexed will have at least 1
						 * array entry - we assume this and use the
						 * first to retrieve the course
						 */
					course: course,
					components: duplicateComponents,
					displayComponents: duplicateComponents,
				};

				duplicateList.push(courseDuplicates);
			}

			return duplicateList;
		},
		[coursesById, duplicateCourseIds, planSelections, requirementsById, skip],
	);

	return duplicateCourses;
};
